/* Extracted from snippets/product-info.liquid */

/* Block: product-selection-summary custom element */
        if (!customElements.get('product-selection-summary')) {
          class ProductSelectionSummary extends HTMLElement {
            connectedCallback() {
              this._form = document.getElementById(this.dataset.form);
              this._variantTitle = this.dataset.variantTitle;
              this._purchaseOption = {
                type: this.dataset.purchaseOption || 'one_time',
                frequency: this.dataset.frequency || null
              };

              this._onVariantChange = (e) => {
                if (e.detail && e.detail.variant) {
                  this._variantTitle = e.detail.variant.title || this._variantTitle;
                  this._render();
                }
              };

              this._onPurchaseOptionChange = (e) => {
                if (e.detail) {
                  this._purchaseOption = e.detail;
                  this._render();
                }
              };

              if (this._form) {
                this._form.addEventListener('variant:change', this._onVariantChange);
                this._form.addEventListener('purchase-option:change', this._onPurchaseOptionChange);
              }
            }

            disconnectedCallback() {
              if (this._form) {
                this._form.removeEventListener('variant:change', this._onVariantChange);
                this._form.removeEventListener('purchase-option:change', this._onPurchaseOptionChange);
              }
            }

            _render() {
              const parts = [this._variantTitle];
              parts.push(this._purchaseOption.type === 'subscription' ? 'Abo' : 'Einzelkauf');
              if (this._purchaseOption.type === 'subscription' && this._purchaseOption.frequency) {
                parts.push('Lieferung alle ' + this._purchaseOption.frequency + ' Tage');
              }
              this.textContent = 'Ausgewählt: ' + parts.join(' · ');
            }
          }

          customElements.define('product-selection-summary', ProductSelectionSummary);
        }

/* Block: price block: shipping info tooltip */
          (function() {
            const link = document.querySelector('.shipping-info-link');
            if (!link) return;

            const tooltipHTML = `
              <div class="shipping-tooltip-overlay">
                <div class="shipping-tooltip-modal" role="dialog" aria-modal="true" aria-labelledby="shipping-tooltip-title">
                  <button class="shipping-tooltip-close" aria-label="Schließen">&times;</button>
                  <strong id="shipping-tooltip-title" class="shipping-tooltip-title">Versand-Informationen</strong>
                  <div class="shipping-tooltip-content">
                    <p>🇩🇪 Lieferungen innerhalb Deutschlands:</p>
                    <ul>
                      <li>Versand mit DHL</li>
                      <li>Innerhalb von 1-3 Werktagen</li>
                      <li>Bestellwert unter 50 € = 3,90 € Versandkosten</li>
                      <li>Ab einem Bestellwert von 50 € = Versandkostenfrei (kostenlos)</li>
                    </ul>
                    <p>🇦🇹 Lieferungen nach Österreich:</p>
                    <ul>
                      <li>Versand mit DHL</li>
                      <li>Innerhalb von 3-5 Werktagen</li>
                      <li>Bestellwert unter 110 € = 8,90 € Versandkosten</li>
                      <li>Ab einem Bestellwert von 110 € = Versandkostenfrei (kostenlos)</li>
                    </ul>
                    <p>Alle Angaben finden sich in unseren <a href="/policies/shipping-policy">Versandrichtlinien</a>.</p>
                  </div>
                </div>
              </div>
            `;

            link.addEventListener('click', function(e) {
              e.preventDefault();
              
              // Insert tooltip if not exists
              if (!document.querySelector('.shipping-tooltip-overlay')) {
                document.body.insertAdjacentHTML('beforeend', tooltipHTML);

                const overlay = document.querySelector('.shipping-tooltip-overlay');
                const closeBtn = overlay.querySelector('.shipping-tooltip-close');

                function closeTooltip() {
                  overlay.classList.remove('active');
                  setTimeout(() => overlay.remove(), 300);
                  document.removeEventListener('keydown', onKeydown);
                }

                function onKeydown(e) {
                  if (e.key === 'Escape') closeTooltip();
                }

                // Close on button click
                closeBtn.addEventListener('click', closeTooltip);

                // Close on overlay click
                overlay.addEventListener('click', function(e) {
                  if (e.target === overlay) closeTooltip();
                });

                // Close on ESC key
                document.addEventListener('keydown', onKeydown);

                setTimeout(() => overlay.classList.add('active'), 10);
              }
            });
          })();

/* Block: enhanced_variant_selector interactions */
              (function() {
                const container = document.querySelector('.product-info__enhanced-variants');
                if (!container) return;
                
                const variantInputs = container.querySelectorAll('.enhanced-variant-option__input');
                const supplyMapEl = document.querySelector('[data-variant-supply-map]');
                let supplyMap = {};
                
                if (supplyMapEl) {
                  try { supplyMap = JSON.parse(supplyMapEl.textContent); } catch(e) {}
                }

                /* CUSTOM: Preselect 3KG variant if no variant in URL */
                const enhancedList = container.querySelector('.enhanced-variant-list');
                const preferredVariantId = enhancedList ? enhancedList.getAttribute('data-preferred-variant-id') : null;
                const hasUrlVariant = enhancedList ? enhancedList.getAttribute('data-has-url-variant') === 'true' : true;

                if (!hasUrlVariant && preferredVariantId) {
                  const preferredInput = container.querySelector('.enhanced-variant-option__input[value="' + preferredVariantId + '"]');
                  if (preferredInput && !preferredInput.disabled) {
                    /* Trigger change after DOM is ready so all listeners are attached */
                    requestAnimationFrame(function() {
                      preferredInput.checked = true;
                      preferredInput.dispatchEvent(new Event('change', { bubbles: true }));
                    });
                  }
                }
                
                function updateBadges(variantId) {
                  const data = supplyMap[variantId];
                  if (!data) return;
                  
                  const priceBadge = document.querySelector('[data-badge-price]');
                  const supplyBadge = document.querySelector('[data-badge-supply]');
                  
                  if (priceBadge) {
                    if (data.per_day_price_formatted && data.day_supply && data.day_supply !== '0' && data.day_supply !== 0) {
                      priceBadge.textContent = data.per_day_price_formatted + ' pro Tag';
                      priceBadge.style.display = '';
                    } else {
                      priceBadge.style.display = 'none';
                    }
                  }
                  
                  if (supplyBadge) {
                    if (data.day_supply && data.day_supply !== '0' && data.day_supply !== 0) {
                      supplyBadge.textContent = data.day_supply + '';
                      supplyBadge.style.display = '';
                    } else {
                      supplyBadge.style.display = 'none';
                    }
                  }
                }

                variantInputs.forEach(input => {
                  input.addEventListener('change', function() {
                    /* Update visual selection */
                    container.querySelectorAll('.enhanced-variant-option').forEach(option => {
                      option.classList.remove('is-selected');
                    });
                    if (this.checked) {
                      this.closest('.enhanced-variant-option').classList.add('is-selected');
                    }
                    
                    /* Update badges */
                    updateBadges(this.value);
                    
                    /* Sync with Impact theme: find the product form and update the hidden variant ID input */
                    const formId = this.getAttribute('form');
                    const productForm = formId ? document.getElementById(formId) : this.closest('form');
                    if (productForm) {
                      const hiddenInput = productForm.querySelector('input[name="id"]') || productForm.id;
                      if (hiddenInput) {
                        hiddenInput.value = this.value;
                        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
                      }
                    }
                    
                    /* Update URL */
                    const newUrl = new URL(window.location.href);
                    newUrl.searchParams.set('variant', this.value);
                    window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());
                  });
                });
              })();

/* Block: quantity-tier-selector custom element */
              if (!customElements.get('quantity-tier-selector')) {
                class QuantityTierSelector extends HTMLElement {
                  connectedCallback() {
                    this.basePrice = parseFloat(this.dataset.basePrice);
                    this.compareAtPrice = parseFloat(this.dataset.compareAtPrice) || 0;
                    this.baseUnitPrice = parseFloat(this.dataset.unitPrice) || 0;
                    this.discountMode = this.dataset.discountMode || 'saving';
                    this.formId = this.dataset.formId;
                    this._applyingPrices = false;

                    /* Tier config */
                    this.tiers = [
                      { tier: '1', qty: parseInt(this.dataset.tier1Qty), discount: parseFloat(this.dataset.tier1Discount) || 0 },
                      { tier: '2', qty: parseInt(this.dataset.tier2Qty), discount: parseFloat(this.dataset.tier2Discount) || 0 },
                      { tier: '3', qty: parseInt(this.dataset.tier3Qty), discount: parseFloat(this.dataset.tier3Discount) || 0 }
                    ];
                    this._currentDiscount = 0;
                    this._form = document.getElementById(this.formId);

                    /* Radio handlers */
                    this.querySelectorAll('input[type="radio"]').forEach(r => {
                      r.addEventListener('change', () => this._onTierChange(r));
                    });

                    /* Bidirectional sync with native quantity input */
                    this._bindQtyInput();

                    /* Form events */
                    if (this._form) {
                      this._rerenderHandler = () => {
                        requestAnimationFrame(() => {
                          this._bindQtyInput();
                          this._readFreshUnitPrice();
                          this._applyCurrentTier();
                          this._setupPriceObserver();
                        });
                      };
                      this._form.addEventListener('product:rerender', this._rerenderHandler);

                      this._variantHandler = (e) => {
                        if (!e.detail?.variant) return;
                        this.basePrice = e.detail.variant.price;
                        this.compareAtPrice = e.detail.variant.compare_at_price || 0;
                        this._updateTierOptionPrices();
                        requestAnimationFrame(() => {
                          this._bindQtyInput();
                          this._readFreshUnitPrice();
                          this._applyCurrentTier();
                          this._setupPriceObserver();
                        });
                      };
                      this._form.addEventListener('variant:change', this._variantHandler);

                      this._formdataHandler = (e) => {
                        const qtyInput = this._getQtyInput();
                        if (qtyInput) e.formData.set('quantity', qtyInput.value);
                      };
                      this._form.addEventListener('formdata', this._formdataHandler);
                    }

                    /* Initial apply — double rAF to run after all other init scripts */
                    requestAnimationFrame(() => {
                      requestAnimationFrame(() => {
                        const checked = this.querySelector('input[type="radio"]:checked');
                        if (checked) {
                          this._onTierChange(checked, true);
                        }
                        this._setupPriceObserver();
                      });
                    });
                  }

                  disconnectedCallback() {
                    if (this._form) {
                      this._form.removeEventListener('product:rerender', this._rerenderHandler);
                      this._form.removeEventListener('variant:change', this._variantHandler);
                      this._form.removeEventListener('formdata', this._formdataHandler);
                    }
                    if (this._qtyInput) {
                      this._qtyInput.removeEventListener('change', this._qtyChangeHandler);
                    }
                    this._priceObserver?.disconnect();
                  }

                  /* ---- MutationObserver: re-apply prices if something resets them ---- */
                  _setupPriceObserver() {
                    this._priceObserver?.disconnect();
                    const productInfo = this.closest('.product-info');
                    if (!productInfo) return;
                    const priceBlock = productInfo.querySelector('[data-block-type="price"]');
                    if (!priceBlock) return;

                    this._priceObserver = new MutationObserver(() => {
                      if (this._applyingPrices || this._currentDiscount === 0) return;
                      /* Check if sale-price still shows our discounted value */
                      const salePrice = priceBlock.querySelector('sale-price');
                      if (!salePrice) return;
                      const expected = this._fmtNum(this.basePrice * (100 - this._currentDiscount) / 100);
                      const current = (salePrice.textContent.match(/[\d]+[.,][\d]+/) || [''])[0];
                      if (current !== expected) {
                        this._applyPricesSafe();
                      }
                    });
                    this._priceObserver.observe(priceBlock, { childList: true, subtree: true, characterData: true });
                  }

                  _applyPricesSafe() {
                    this._applyingPrices = true;
                    this._syncAllPrices();
                    /* Reset flag after mutations from our changes have been processed */
                    setTimeout(() => { this._applyingPrices = false; }, 50);
                  }

                  /* ---- Bind to native qty input & listen for manual changes ---- */
                  _bindQtyInput() {
                    if (this._qtyInput && this._qtyChangeHandler) {
                      this._qtyInput.removeEventListener('change', this._qtyChangeHandler);
                    }
                    this._qtyInput = this._getQtyInput();
                    if (this._qtyInput) {
                      this._qtyChangeHandler = () => this._onQtyInputChange();
                      this._qtyInput.addEventListener('change', this._qtyChangeHandler);
                    }
                  }

                  _getQtyInput() {
                    return document.querySelector(
                      `input[name="quantity"][form="${this.formId}"]`
                    ) || document.querySelector(
                      `#${CSS.escape(this.formId)} input[name="quantity"]`
                    );
                  }

                  /* ---- When user manually changes qty in the native selector ---- */
                  _onQtyInputChange() {
                    if (this._settingQty) return;
                    const qty = parseInt(this._qtyInput?.value) || 1;
                    const tier = this._getTierForQty(qty);
                    const radio = this.querySelector(`input[data-tier="${tier.tier}"]`);
                    if (radio && !radio.checked) {
                      radio.checked = true;
                      this.querySelectorAll('.tier-option').forEach(o => o.classList.remove('tier-option--selected'));
                      this.querySelector(`.tier-option[data-tier="${tier.tier}"]`)?.classList.add('tier-option--selected');
                    }
                    this._currentDiscount = tier.discount;
                    this._applyPricesSafe();
                  }

                  _getTierForQty(qty) {
                    const sorted = [...this.tiers].sort((a, b) => b.qty - a.qty);
                    for (const t of sorted) {
                      if (qty >= t.qty) return t;
                    }
                    return this.tiers[0];
                  }

                  /* ---- Tier radio clicked ---- */
                  _onTierChange(radio, isInit) {
                    const tier = radio.dataset.tier;
                    const qty = parseInt(radio.value);
                    this._currentDiscount = parseFloat(radio.dataset.discount) || 0;

                    this.querySelectorAll('.tier-option').forEach(o => o.classList.remove('tier-option--selected'));
                    this.querySelector(`.tier-option[data-tier="${tier}"]`)?.classList.add('tier-option--selected');

                    this._setQtyOnInput(qty);
                    this._applyPricesSafe();
                  }

                  _applyCurrentTier() {
                    const checked = this.querySelector('input[type="radio"]:checked');
                    if (checked) {
                      this._setQtyOnInput(parseInt(checked.value));
                    }
                    this._applyPricesSafe();
                  }

                  _setQtyOnInput(qty) {
                    const input = this._getQtyInput();
                    if (!input) return;
                    this._settingQty = true;
                    if (typeof input.quantity !== 'undefined') {
                      input.quantity = qty;
                    } else {
                      input.value = qty;
                    }
                    this._settingQty = false;
                  }

                  _readFreshUnitPrice() {
                    const productInfo = this.closest('.product-info');
                    if (!productInfo) return;
                    const unitEl = productInfo.querySelector('.product-info__price unit-price');
                    if (unitEl) {
                      const parsed = this._parseMoneyFromText(unitEl.textContent);
                      if (parsed !== null) this.baseUnitPrice = parsed;
                    }
                  }

                  _updateTierOptionPrices() {
                    this.querySelectorAll('.tier-option').forEach(option => {
                      const radio = option.querySelector('input[type="radio"]');
                      const discount = parseFloat(radio.dataset.discount) || 0;
                      const multiplier = (100 - discount) / 100;
                      const newPrice = this.basePrice * multiplier;

                      const priceEl = option.querySelector('.tier-price');
                      if (priceEl) priceEl.textContent = this._fmt(newPrice);

                      const compareEl = option.querySelector('.tier-compare-price');
                      if (compareEl && discount > 0) compareEl.textContent = this._fmt(this.basePrice);
                    });
                  }

                  /* ---- Sync ALL price elements in the buy-box ---- */
                  _syncAllPrices() {
                    const discount = this._currentDiscount;
                    const multiplier = (100 - discount) / 100;
                    const discounted = this.basePrice * multiplier;

                    const productInfo = this.closest('.product-info');
                    if (!productInfo) return;

                    const priceList = productInfo.querySelector('.product-info__price price-list');
                    if (!priceList) return;

                    /* 1) sale-price — modify only the text node, keep .sr-only span intact */
                    const salePrice = priceList.querySelector('sale-price');
                    if (salePrice) {
                      let textNode = null;
                      for (const node of salePrice.childNodes) {
                        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
                          textNode = node;
                        }
                      }
                      if (textNode) {
                        textNode.textContent = this._fmt(discounted);
                      } else {
                        salePrice.appendChild(document.createTextNode(this._fmt(discounted)));
                      }

                      if (discount > 0 || this.compareAtPrice > this.basePrice) {
                        salePrice.classList.add('text-on-sale');
                      } else {
                        salePrice.classList.remove('text-on-sale');
                      }
                      if (!salePrice.classList.contains('text-lg')) salePrice.classList.add('text-lg');
                    }

                    /* 2) compare-at-price */
                    let compareEl = priceList.querySelector('compare-at-price');
                    const showCompare = discount > 0 || this.compareAtPrice > this.basePrice;
                    const compareValue = discount > 0 ? this.basePrice : this.compareAtPrice;

                    if (showCompare) {
                      if (!compareEl) {
                        compareEl = document.createElement('compare-at-price');
                        compareEl.className = 'text-subdued line-through';
                        if (salePrice) salePrice.after(compareEl);
                      }
                      let cTextNode = null;
                      for (const node of compareEl.childNodes) {
                        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
                          cTextNode = node;
                        }
                      }
                      if (cTextNode) {
                        cTextNode.textContent = this._fmt(compareValue);
                      } else {
                        compareEl.appendChild(document.createTextNode(this._fmt(compareValue)));
                      }
                      compareEl.style.display = '';
                    } else if (compareEl) {
                      compareEl.style.display = 'none';
                    }

                    /* 3) unit-price — replace only the number */
                    const unitEl = productInfo.querySelector('.product-info__price unit-price');
                    if (unitEl && this.baseUnitPrice > 0) {
                      const newUnitPrice = this.baseUnitPrice * multiplier;
                      const numStr = this._fmtNum(newUnitPrice);
                      unitEl.textContent = unitEl.textContent.replace(/[\d]+[.,][\d]+/, numStr);
                    }

                    /* 4) on-sale-badge "Spare X €" */
                    const badgeEl = productInfo.querySelector('.product-info__price on-sale-badge');
                    if (badgeEl) {
                      const effectiveCompare = this.compareAtPrice > this.basePrice ? this.compareAtPrice : this.basePrice;
                      if (discount > 0 || this.compareAtPrice > this.basePrice) {
                        const savings = effectiveCompare - discounted;
                        if (this.discountMode === 'percentage') {
                          const pct = Math.round((savings / effectiveCompare) * 100);
                          badgeEl.textContent = 'Spare ' + pct + '%';
                        } else {
                          badgeEl.textContent = 'Spare ' + this._fmt(savings);
                        }
                        badgeEl.closest('.product-info__badge-list')?.style.removeProperty('display');
                      } else {
                        badgeEl.closest('.product-info__badge-list')?.style.setProperty('display', 'none');
                      }
                    }
                  }

                  _parseMoneyFromText(text) {
                    const match = text.match(/([\d]+[.,][\d]{2})/);
                    if (!match) return null;
                    return Math.round(parseFloat(match[1].replace(',', '.')) * 100);
                  }

                  /* Format cents → "35,91 €" */
                  _fmt(cents) {
                    if (typeof cents !== 'number' || isNaN(cents)) return '';
                    return (cents / 100).toFixed(2).replace('.', ',') + '\u00A0€';
                  }

                  /* Format cents → "35,91" (number only, no currency) */
                  _fmtNum(cents) {
                    if (typeof cents !== 'number' || isNaN(cents)) return '';
                    return (cents / 100).toFixed(2).replace('.', ',');
                  }
                }

                customElements.define('quantity-tier-selector', QuantityTierSelector);
              }

/* Block: volume-pricing-table custom element */
              if (!customElements.get('volume-pricing-table')) {
                class VolumePricingTable extends HTMLElement {
                  connectedCallback() {
                    this._onQty = () => this._updateActive();
                    this._onFormUpdate = () => {
                      requestAnimationFrame(() => this._bind());
                    };

                    this._form = document.getElementById(this.dataset.formId);
                    this._bind();

                    if (this._form) {
                      this._form.addEventListener('product:rerender', this._onFormUpdate);
                      this._form.addEventListener('variant:change', this._onFormUpdate);
                    }
                  }

                  disconnectedCallback() {
                    this._qty?.removeEventListener('change', this._onQty);
                    this._qty?.removeEventListener('input', this._onQty);

                    if (this._form) {
                      this._form.removeEventListener('product:rerender', this._onFormUpdate);
                      this._form.removeEventListener('variant:change', this._onFormUpdate);
                    }
                  }

                  _bind() {
                    this._qty?.removeEventListener('change', this._onQty);
                    this._qty?.removeEventListener('input', this._onQty);

                    this._form = document.getElementById(this.dataset.formId) || this._form;
                    this._qty = this._form?.querySelector('input[name="quantity"][is="quantity-input"]')
                      || this._form?.querySelector('input[name="quantity"]')
                      || document.querySelector(`input[name="quantity"][form="${this.dataset.formId}"]`);

                    this._qty?.addEventListener('change', this._onQty);
                    this._qty?.addEventListener('input', this._onQty);
                    this._updateActive();
                  }

                  _updateActive() {
                    const qty = parseInt(this._qty?.value || '1', 10);
                    const rows = Array.from(this.querySelectorAll('[data-min-qty]'));
                    if (!rows.length) return;

                    let active = rows[0];
                    for (const row of rows) {
                      if (qty >= parseInt(row.dataset.minQty, 10)) {
                        active = row;
                      }
                    }

                    rows.forEach((row) => {
                      const isActive = row === active;
                      row.classList.toggle('is-active', isActive);
                      row.setAttribute('aria-current', isActive ? 'true' : 'false');
                    });
                  }
                }

                customElements.define('volume-pricing-table', VolumePricingTable);
              }

/* Block: purchase-option-selector custom element */
              if (!customElements.get('purchase-option-selector')) {
                class PurchaseOptionSelector extends HTMLElement {
                  connectedCallback() {
                    this._form = document.getElementById(this.dataset.form);
                    this._discount = parseFloat(this.dataset.discount) || 0;
                    this._sellingPlanId = this.dataset.sellingPlanId || null;
                    this._sellingPlanInput = this.querySelector('.purchase-option__selling-plan-input');
                    this._frequencyRow = this.querySelector('.purchase-option-selector__frequency-row');
                    this._frequencySelect = this.querySelector('.purchase-option__frequency-select');

                    this._onInputChange = (input) => this._onChange(input);

                    this.querySelectorAll('.purchase-option__input').forEach((input) => {
                      input.addEventListener('change', () => this._onInputChange(input));
                    });

                    if (this._frequencySelect) {
                      this._frequencySelect.addEventListener('change', () => this._dispatch());
                    }
                  }

                  _onChange(input) {
                    const type = input.value;

                    this.querySelectorAll('.purchase-option').forEach((label) => {
                      const isSelected = label.dataset.type === type;
                      label.classList.toggle('is-selected', isSelected);
                      label.dataset.selected = isSelected ? 'true' : 'false';
                    });

                    if (this._frequencyRow) {
                      this._frequencyRow.hidden = type !== 'subscription';
                    }

                    if (this._sellingPlanInput) {
                      this._sellingPlanInput.value = type === 'subscription' ? (this._sellingPlanId || '') : '';
                    }

                    this._dispatch();
                  }

                  _dispatch() {
                    const checked = this.querySelector('.purchase-option__input:checked');
                    const type = checked ? checked.value : 'one_time';
                    const frequency = (type === 'subscription' && this._frequencySelect) ? this._frequencySelect.value : null;

                    if (this._form) {
                      this._form.dispatchEvent(new CustomEvent('purchase-option:change', {
                        bubbles: true,
                        detail: { type, frequency, discount: this._discount }
                      }));
                    }
                  }
                }

                customElements.define('purchase-option-selector', PurchaseOptionSelector);
              }

